/**
 * Single conversion destination for the entire landing page.
 * Every CTA on the site points to this exact WhatsApp link.
 */
export const WHATSAPP_ORDER_LINK =
  'https://wa.me/50687704113?text=Hola%2C%20Blue%20%26%20White.%20Quiero%20ver%20los%20sabores%20disponibles%20y%20hacer%20un%20pedido.'

export const PHONE_DISPLAY = '+506 8770 4113'
